import { useQuery } from "react-query"
import { request } from "../util/request"

export interface Donation {
  id: number
  amount: number
  status: string
  created_at: string
}

interface MyDonationsResponse {
  success: boolean
  tips: Donation[]
}

export function useMyDonationsForPost(postId: number, enabled = true) {
  return useQuery<MyDonationsResponse, Error>(
    ["myDonations", postId],
    () =>
      request({
        queryKey: [
          "myDonations",
          { path: `/api/v1/posts/${postId}/tips/my_donations` },
        ],
      }),
    { enabled: enabled && !!postId },
  )
}
